export default __webpack_public_path__ + "static/media/info-close.ff1a7c6e.svg";